/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components'
import { FormSection as FormSectionLegacy } from '@fitinsur/components'

import { Row } from "components/Grid";

import { GeneralSection } from '../../general/index';
import { InsurerTaxesSection } from '../../insurerTaxes/index';

function RenderSection({
  disableAll,
  values,
  setFieldValue,
  errors,
  setFieldError,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  insurerGroup,
  setInsurerGroup,
  feePayableByGroup,
  setFeePayableByGroup,
  insurersTaxes,
  canGroup,
  setCanGroup,
  setIsGrouped,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  operation,
  loading,
  mc,
  legacyFormSection
}) {

  const FormComponent = legacyFormSection ? FormSectionLegacy : FormSection

  return (
    <>
      <Row>
        <GeneralSection.components.Styled.Title>
          RATES & BASIS
        </GeneralSection.components.Styled.Title>
      </Row>

      <FormComponent
        sectionName="TAX_RATES"
        disableAll={disableAll}
        formikRef={formikRef}
        values={values}
        setFieldValue={setFieldValue}
        errors={errors}
        setFieldError={setFieldError}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        idOperation={idOperation}
        idOperationParent={idOperationParent}
        idProduct={idProduct}
        isInverse={true}
        ignoreModality
        onQuestionChange={(
          question,
          value,
          setFieldValue,
          questionnaireUpdated
        ) => {
          loading.start();
          InsurerTaxesSection.events.handleTaxes({
            answerTax: value,
            insurersAll: null,
            handleSwitch: true,
            insurerGroup,
            setInsurerGroup,
            feePayableByGroup,
            setFeePayableByGroup,
            insurersTaxes,
            canGroup,
            setCanGroup,
            setIsGrouped,
            globalQuestionnaire,
            setGlobalQuestionnaire,
            questionnaireAnswersToDelete,
            setQuestionnaireAnswersToDelete,
            operation,
            loading,
            mc,
          });
        }}
      />
    </>
  )
}

const components = {
  RenderSection
}

export { components }